function Slogan({text}) {
    return (
        <div className="banner-text-info">
            <h1 className="bnr-text">{text}</h1>
        </div>
    )
}

export default Slogan;